module.exports = __webpack_public_path__ + "img/artillery-wagon-base-9.4381ec32.png";